import React, { InputHTMLAttributes, ReactElement } from 'react'
import classNames from 'classnames'

type InputFieldProps = InputHTMLAttributes<HTMLInputElement>

export default function StandaloneInput({
  name,
  className,
  ...props
}: InputFieldProps): ReactElement {
  return (
    <input
      id={name}
      className={classNames(
        className,
        'block w-full rounded-md border-0 py-1.5 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-blue-600 sm:text-sm sm:leading-6'
      )}
      {...props}
    />
  )
}

StandaloneInput.defaultProps = {
  type: 'text',
}
